import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthProvider";

const publicRoutes = ["/", "/login"];

export default function RootOutlet() {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();

  if (isAuthenticated && (pathname === "/" || pathname === "/login")) {
    return <Navigate to="/dashboard" replace />;
  }

  if (!isAuthenticated && !publicRoutes.includes(pathname)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
